import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { defaultTo } from 'ramda';

import { useAppContext } from '../../../../../../AppModulesWrapper';

import { selectAnalyticsProduct } from '../../../../../selectors/analytics';
import {
  selectIsPackagesAvailable,
  selectIsPackageSelected,
  selectActivePackageServiceId,
  selectActivePackage,
} from '../../../../../reducers/v2/publicationPackages/selectors';

import { ITrackPublicationWrapperShowExtra } from '../types';

export const usePublicationLayoutShowAnalytics = () => {
  const { analytics } = useAppContext();

  const analyticsProduct = useSelector(selectAnalyticsProduct);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const isPackageSelected = useSelector(selectIsPackageSelected);
  const activePackageServiceId = useSelector(selectActivePackageServiceId);
  const activePackage = useSelector(selectActivePackage);

  useEffect(() => {
    analytics.send<ITrackPublicationWrapperShowExtra>({
      action: 'publish_terms_block_show',
      label: 'publication',
      products: [analyticsProduct],
      extra: {
        type: 'fvu_new',
        pack_available: isPackagesAvailable ? 1 : 0,
        pack_chosen: isPackageSelected ? 1 : 0,
        ...defaultTo({}, activePackageServiceId && { publication_type: activePackageServiceId }),
        ...defaultTo(
          {},
          activePackage && {
            package_info: {
              id: activePackage.id,
              price: activePackage.price,
              cnt: activePackage.offersCount,
              marketingPrice: activePackage.marketingPrice,
            },
          },
        ),
      },
    });
  }, [activePackage, activePackageServiceId, analytics, analyticsProduct, isPackageSelected, isPackagesAvailable]);
};
